var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1159_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.733 9.014C21.964 8.315 20.967 7.957 19.935 8.004C18.899 8.053 17.944 8.502 17.245 9.27L14.807 11.95C14.16 11.36 13.3 11.001 12.358 11.001H3.5C1.57 11.001 0 12.571 0 14.501V20.501C0 22.431 1.57 24.001 3.5 24.001H14.681L23.015 14.469C24.425 12.889 24.298 10.442 22.734 9.015L22.733 9.014ZM20.766 12.483L13.319 21.001H3.5C3.225 21.001 3 20.776 3 20.501V14.501C3 14.226 3.225 14.001 3.5 14.001H12.357C12.711 14.001 13 14.289 13 14.644C13 14.961 12.764 15.235 12.449 15.279L7.288 16.016L7.712 18.987L12.873 18.25C14.492 18.019 15.749 16.72 15.967 15.134L19.464 11.291C19.623 11.116 19.84 11.014 20.076 11.003C20.324 10.984 20.538 11.073 20.712 11.232C21.068 11.556 21.097 12.113 20.767 12.484L20.766 12.483ZM6 2.5C6 1.119 7.119 0 8.5 0C9.881 0 11 1.119 11 2.5C11 3.881 9.881 5 8.5 5C7.119 5 6 3.881 6 2.5ZM13 9H4V8C4 6.895 4.895 6 6 6H11C12.105 6 13 6.895 13 8V9Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1159_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.32d96f1d4dc432a6f551e172d5856d25.svg";
export { ForwardRef as ReactComponent };